import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePageViewEvent } from "../ga4/builders/pageView";
import { useNavigation } from "../../hooks/useNavigation";
import { defaultDataLayerData } from "tracking/tools/dataLayer";
import { useUser } from "model/user/UserContext";

const PageViewEventTracker = ({ children }: { children?: ReactNode }) => {
  const { pathname } = useLocation();
  const { lastLocation } = useNavigation();
  const trackPageView = usePageViewEvent();
  const { isFetched } = useUser();
  const funnelFlow = (): string => {
    if (pathname.includes("barcode/scanner")) return "barcodeFlow";
    if (pathname.includes("barcode/uploader")) return "uploaderFlow";

    return "defaultFlow";
  };

  const funnelType = funnelFlow();

  useEffect(() => {
    if (!isFetched || defaultDataLayerData.brand === undefined) return;
    const previousPageUrl = lastLocation?.pathname;
    trackPageView({ previousPageUrl, funnelType });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, defaultDataLayerData.brand, isFetched]);

  return <>{children}</>;
};

export default PageViewEventTracker;
